import React from 'react';
import { format } from 'date-fns';

import { Badge } from '@dashboard/components/ui/badge';

const EVENTS = {
  connected: { label: 'Connected', variant: 'success' },
  disconnected: { label: 'Disconnected', variant: 'secondary' },
  revoked: { label: 'Revoked by provider', variant: 'destructive' },
};

const PROVIDERS = {
  google: 'Google',
  slack: 'Slack',
};

const formatDate = value => format(new Date(value), 'd MMM, yyyy, HH:mm');

export default function OAuthConnectionHistory({ history = [] }) {
  if (!history.length) {
    return (
      <span className="text-gray-500 dark:text-muted-foreground">
        No connection history recorded
      </span>
    );
  }

  const entries = [...history].reverse();

  return (
    <ul className="space-y-3">
      {entries.map((entry, index) => {
        const { label, variant } = EVENTS[entry.event] ?? {
          label: entry.event,
          variant: 'secondary',
        };

        return (
          <li key={`${entry.at}-${index}`}>
            <div className="flex items-center gap-x-2 gap-y-1">
              <span className="text-gray-500 dark:text-muted-foreground">
                {PROVIDERS[entry.provider] ?? entry.provider}
              </span>
              <span>{entry.account || 'Unknown account'}</span>
              <Badge variant={variant}>{label}</Badge>
            </div>
            <div className="text-xs text-gray-500 dark:text-muted-foreground">
              <span>{formatDate(entry.at)}</span>
              {entry.reason && (
                <>
                  {' · '}
                  <span>{entry.reason}</span>
                </>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
